import { ResponsiveMediaProps } from 'libs/contentful/props';
import Image from 'next/image';
import { cn } from 'utils/styles';

const ResponsiveMedia = ({ desktopImage, mobileImage, className, testId }: ResponsiveMediaProps) => {
  return (
    <div className={cn(className)} data-testid={testId}>
      {/* Desktop Image */}
      <div className="hidden md:block">
        <Image
          src={desktopImage.url}
          alt={desktopImage.description ?? desktopImage.title}
          height={desktopImage.height}
          width={desktopImage.width}
        />
      </div>

      {/* Mobile Image */}
      <div className="block md:hidden">
        {mobileImage ? (
          <Image
            src={mobileImage.url}
            alt={mobileImage.description ?? mobileImage.title}
            height={mobileImage.height}
            width={mobileImage.width}
          />
        ) : (
          <Image
            src={desktopImage.url}
            alt={desktopImage.description ?? desktopImage.title}
            height={desktopImage.height}
            width={desktopImage.width}
          />
        )}
      </div>
    </div>
  );
};
export default ResponsiveMedia;
